import { lang } from '../../assets/lang'
import { sequenceHours, timezones } from '../../data'
import { getSelectOptionsFromArrayOfObjects } from '../../utils/functions'

export const sequenceHtml =
'<div class="form-group text-left mt-2">' +
  '<label for="sequence-sequence-name">' + lang.sequence_html_label_name + '</label>' +
  '<input id="sequence-sequence-name" class="form-control" type="text">' +
'</div>' +

'<p class="text-muted small mt-4">' + lang.sequence_html_info_non_promotional_requirements + '</p>' +

'<div class="row">' +
  '<div class="col-6 pr-2">' +
    '<div id="sequence-sequence-starting-time-group" class="button-onDemand-field form-group text-left mt-2">' + 
      '<label for="sequence-sequence-starting-time">' + lang.sequence_html_label_start_time + '</label>' +
      '<select id="sequence-sequence-starting-time" class="form-control select2">' +
        '<option value="" selected>' + lang.sequence_html_title_select + '</option>' +
        getSelectOptionsFromArrayOfObjects(sequenceHours) +
      '</select>' +
    '</div>' +
  '</div>' +
  '<div class="col-6 pl-2">' +
    '<div id="sequence-sequence-closing-time-group" class="button-onDemand-field form-group text-left mt-2">' + 
      '<label for="sequence-sequence-closing-time">' + lang.sequence_html_label_closing_time + '</label>' +
      '<select id="sequence-sequence-closing-time" class="form-control select2">' +
        '<option value="" selected>' + lang.sequence_html_title_select + '</option>' +
        getSelectOptionsFromArrayOfObjects(sequenceHours) +
      '</select>' +
    '</div>' +
  '</div>' +  
'</div>' +

'<div id="sequence-sequence-timezone-group" class="button-onDemand-field form-group text-left mt-2">' + 
  '<label for="sequence-sequence-timezone">' + lang.sequence_html_label_timezone + '</label>' +
  '<select id="sequence-sequence-timezone" class="form-control select2">' +
    '<option value="" selected>' + lang.sequence_html_title_select + '</option>' +
    getSelectOptionsFromArrayOfObjects(timezones) +
  '</select>' +
'</div>' +

'<div id="sequence-sequence-message-tag-group" class="button-onDemand-field form-group text-left mt-2">' + 
  '<label for="sequence-sequence-message-tag">' + lang.sequence_html_label_message_tag + '</label>' +
  '<select id="sequence-sequence-message-tag" class="form-control select2">' +
    '<option value="" selected>' + lang.sequence_html_title_select + '</option>' +
  '</select>' +
'</div>'
